<template>
    <div class="surface-overlay px-6 shadow-2 flex flex-column relative lg:static">

        <!-- ROW 1: Header -->
        <div class="py-3 flex align-items-center justify-content-between" style="min-height: 80px">

            <img src="images/blocks/logos/kitrin-logo-black-revised-software-rev2.png"
                 alt="IsoEvolve" height="50" class="mr-0 lg:mr-6"/>

            <!-- Mobile toggle -->
            <a
                v-ripple
                class="cursor-pointer block lg:hidden text-700 mt-1 p-ripple"
                v-styleclass="{
                  selector: '@next',
                  enterClass: 'hidden',
                  leaveToClass: 'hidden',
                  hideOnOutsideClick: true
              }"
            >
                <i class="pi pi-bars text-4xl"></i>
            </a>

            <!-- Main Navigation Wrapper -->
            <div
                class="navbar-wrapper align-items-center flex-grow-1 justify-content-between hidden lg:flex absolute lg:static w-full surface-overlay left-0 top-100 z-1 shadow-2 lg:shadow-none"
            >
                <!-- existing menu unchanged -->

                <ul class="list-none p-0 m-0 flex lg:align-items-center select-none flex-column lg:flex-row">

                    <li>
                        <a
                            v-ripple
                            @click="processClients"
                            class="flex px-3 py-2 lg:px-2 lg:py-2 align-items-center text-600 hover:text-900 hover:surface-100 font-medium border-round-sm cursor-pointer">
                            <i class="pi pi pi-user mr-2"></i>
                            <span>Clients</span>
                        </a>
                    </li>

                    <li>
                        <a
                            v-ripple
                            @click="processClientSegments"
                            class="flex px-3 py-2 lg:px-2 lg:py-2 align-items-center text-600 hover:text-900 hover:surface-100 font-medium border-round-sm cursor-pointer">
                            <i class="pi pi pi-users mr-2"></i>
                            <span>Client Segments</span>
                        </a>
                    </li>

                    <li>
                        <a
                            v-ripple
                            @click="processTasks"
                            class="flex px-3 py-2 lg:px-2 lg:py-2 align-items-center text-600 hover:text-900 hover:surface-100 font-medium border-round-sm cursor-pointer">
                            <i class="pi pi-list mr-2"></i>
                            <span>Tasks</span>
                        </a>
                    </li>

                    <!-- Calendar as single item -->
                    <li>
                        <a
                            v-ripple
                            @click="processCalendar"
                            class="flex px-3 py-2 lg:px-2 lg:py-2 align-items-center text-600 hover:text-900 hover:surface-100 font-medium border-round-sm cursor-pointer">
                            <i class="pi pi-calendar mr-2"></i>
                            <span>Calendar</span>
                        </a>
                    </li>

                    <li v-for="section in menu" :key="section.label" class="lg:relative">

                        <a
                            v-ripple
                            class="flex px-3 py-2 lg:px-2 lg:py-2 align-items-center text-600 hover:text-900 hover:surface-100 font-medium border-round-sm cursor-pointer transition-colors"
                            v-styleclass="{
                              selector: '@next',
                              enterClass: 'hidden',
                              enterActiveClass: 'scalein',
                              leaveToClass: 'hidden',
                              leaveActiveClass: 'fadeout',
                              hideOnOutsideClick: true
                            }">
                            <i :class="section.icon + ' mr-2'"></i>
                            <span>{{ section.label }}</span>
                            <i class="pi pi-angle-down ml-1 lg:ml-3"></i>
                        </a>

                        <!-- Dropdown -->
                        <ul class="nav-dropdown list-none py-3 px-6 m-0 lg:px-0 lg:py-0
                     border-round-sm shadow-0 lg:shadow-2 lg:border-1 border-50
                     lg:absolute surface-overlay hidden origin-top w-full w-full md:w-13rem lg:w-15rem cursor-pointer">

                            <li v-for="item in section.items" :key="item.label">
                                <a
                                    v-ripple
                                    @click="item.action"
                                    class="flex p-3 align-items-center text-600 hover:text-900 hover:surface-100 transition-colors cursor-pointer"
                                >
                                    <i :class="item.icon + ' mr-2'"></i>
                                    <span class="font-medium">{{ item.label }}</span>
                                </a>
                            </li>

                        </ul>

                    </li>

                </ul>

                <!-- RIGHT ICONS -->
                <ul
                    class="list-none p-0 m-0 flex lg:align-items-center
                           select-none flex-column lg:flex-row border-top-1 surface-border
                           lg:border-top-none">

                    <li>
                        <a
                            v-ripple
                            @click="processHelp"
                            class="flex px-3 py-2 lg:px-2 lg:py-2 align-items-center text-600 hover:text-900
                            hover:surface-100 font-medium border-round-sm cursor-pointer transition-colors">
                            <i class="pi pi-question-circle text-2xl"></i>
                        </a>
                    </li>

                    <li v-for="section in rightMenu" :key="section.label" class="lg:relative">

                        <!-- Dropdown trigger -->
                        <a
                            v-ripple
                            class="flex px-3 py-2 lg:px-2 lg:py-2 align-items-center
                                   text-600 hover:text-900 hover:surface-100 font-medium
                                   border-round-sm cursor-pointer transition-colors"
                            v-styleclass="{
                                selector: '@next',
                                enterClass: 'hidden',
                                enterActiveClass: 'scalein',
                                leaveToClass: 'hidden',
                                leaveActiveClass: 'fadeout',
                                hideOnOutsideClick: true
                            }">
                            <i :class="section.icon + ' text-2xl'"></i>
                            <i class="pi pi-angle-down ml-1"></i>
                        </a>

                        <!-- Dropdown menu -->
                        <ul class="nav-dropdown list-none py-3 px-6 m-0 lg:px-0 lg:py-0
                               border-round-sm shadow-0 lg:shadow-2 lg:border-1 border-50
                               lg:absolute surface-overlay hidden origin-top w-full w-full md:w-13rem lg:w-15rem cursor-pointer"
                            style="right: 0; left: auto;">

                            <li v-for="item in section.items" :key="item.label">
                                <a
                                    v-ripple
                                    @click="item.action"
                                    class="flex p-3 align-items-center text-600 hover:text-900
                                        hover:surface-100 transition-colors cursor-pointer">
                                    <i :class="item.icon + ' mr-2'"></i>
                                    <span class="font-medium">{{ item.label }}</span>
                                </a>
                            </li>

                        </ul>
                    </li>

                    <li>
                        <a
                            v-ripple
                            @click="processLogout"
                            class="flex px-3 py-2 lg:px-2 lg:py-2 align-items-center
                                   text-600 hover:text-900 hover:surface-100 font-medium
                                   border-round-sm cursor-pointer transition-colors">
                            <i class="pi pi-power-off text-2xl"></i>
                        </a>
                    </li>

                </ul>

            </div>
        </div>

        <div v-if="companies.length > 1" class="grid">
            <div class="col-12 md:col-12">
                <div class="card p-fluid">
                    <div class="field">
                        <Dropdown v-model="selectedCompany" :options="companies"
                                  optionLabel="name" optionValue="id" placeholder="Select a Company"
                                  @update:modelValue="onToggleCompany"/>
                    </div>
                </div>
            </div>
        </div>

        <!-- ROW 2: Breadcrumb -->
        <ul class="list-none py-2 px-0 m-0 flex align-items-center font-medium overflow-x-auto w-full">
            <li class="pr-3"><a @click="processDashboard" class="cursor-pointer"><i
                class="pi pi-home text-text-900"></i></a></li>
            <li class="px-2"><i class="pi pi-angle-right text-900"></i></li>
            <li class="px-2"><a class="cursor-pointer text-900 white-space-nowrap">{{
                    this.userStore.companyName
                }}</a></li>
            <li class="px-2"><i class="pi pi-angle-right text-900"></i></li>
            <li class="px-2"><a class="cursor-pointer text-900 white-space-nowrap">{{
                    this.userStore.user.username
                }}</a></li>
        </ul>

        <div style="height: 8px;"></div>

    </div>
</template>


<script>

import UserService from "@/service/UserService";
import {useUserStore} from "@/stores/UserStore";

export default {
    setup() {
        const userStore = useUserStore()

        return {
            userStore
        }
    },
    async mounted() {
        try {
            await UserService.getUserPing();
        } catch (e) {
            this.userStore.clearUser();
            this.$router.push("login");
            return;
        }

        if (this.userStore.user === undefined) {
            this.userStore.clearUser;
            this.$router.push('login');
        } else {
            this.companies = this.userStore.companies;

            if ((this.userStore.companies.length > 0) && (this.userStore.activeCompanyId === null)) {
                this.userStore.activeCompanyId = this.userStore.companies[0].id;
                this.selectedCompany = this.userStore.companies[0].id;
            } else {
                this.selectedCompany = this.userStore.activeCompanyId;
            }

            try {
                const userData = await UserService.getUser(this.userStore.user.id);
                this.profile = userData.data;
            } catch (e) {
                this.userStore.clearUser();
                this.$router.push('login');
            }

            if (this.profile.roles.includes('ROLE_ADMIN')) {
                const configMenu = this.rightMenu.find(m => m.label === "Account");

                if (configMenu) {
                    configMenu.items.push({
                        label: "Admin Interface",
                        icon: "pi pi-sun",
                        action: this.processAccountAdmin
                    });
                }

            }

            if (this.profile.roles.includes('ROLE_ISOLEARN')) {
                const configMenu = this.rightMenu.find(m => m.label === "Account");

                if (configMenu) {
                    configMenu.items.push({
                        label: "SI Admin Interface",
                        icon: "pi pi-sun",
                        action: this.processAccountSiAdmin
                    });
                }

            }
        }
    },
    data() {
        return {
            profile: null,
            companies: [],
            selectedCompany: null,
            rightMenu: [
                {
                    label: "Configuration",
                    icon: "pi pi-cog",
                    items: [
                        {label: "Basic Details", icon: "pi pi-cog", action: this.processConfigurationBasic},
                        {label: "Business", icon: "pi pi-briefcase", action: this.processConfigurationBusiness},
                        {label: "Team", icon: "pi pi-users", action: this.processConfigurationTeam},
                        {label: "Bank Accounts", icon: "pi pi-wallet", action: this.processConfigurationBankAccount},
                        // {label: "Practitioners", icon: "pi pi-users", action: this.processConfigurationPractitioners},
                        {label: "Billing", icon: "pi pi-credit-card", action: this.processConfigurationBilling},
                        {label: "Email", icon: "pi pi-envelope", action: this.processConfigurationEmail},
                        {label: "Locations", icon: "pi pi-map-marker", action: this.processConfigurationLocations},
                        {label: "Email Templates", icon: "pi pi-file", action: this.processConfigurationEmailTemplates},
                        {label: "Note Templates", icon: "pi pi-book", action: this.processConfigurationNoteTemplates},
                        {label: "Provisions", icon: "pi pi-sliders-h", action: this.processConfigurationProvisions},
                        {label: "Availability", icon: "pi pi-calendar", action: this.processConfigurationAvailability},
                        {label: "Labels", icon: "pi pi-tag", action: this.processConfigurationLabels}
                    ]
                },
                {
                    label: "Account",
                    icon: "pi pi-user",
                    items: [
                        {label: "Profile", icon: "pi pi-id-card", action: this.processAccountOverview},
                        {label: "Security", icon: "pi pi-lock", action: this.processAccountSecurity},
                        {label: "Subscription Details", icon: "pi pi-credit-card", action: this.processAccountPrepaid},
                        {label: "Terms of Use", icon: "pi pi-file", action: this.processAccountTermsOfUse},
                        {label: "Privacy Policy", icon: "pi pi-shield", action: this.processAccountPrivacyPolicy},
                        {label: "Application Store", icon: "pi pi-shopping-bag", action: this.processAccountApplicationStore}
                    ]
                }
            ],
            menu: [
                {
                    label: "Advanced",
                    icon: "pi pi-chart-bar",
                    items: [
                        {label: "Dashboard", icon: "pi pi-home", action: this.processDashboard},
                        {label: "Appointments", icon: "pi pi-calendar", action: this.processAppointments},
                        {label: "Prospects", icon: "pi pi-users", action: this.processProspects},
                        {label: "Digital Forms", icon: "pi pi-users", action: this.processDigitalForms},
                        {label: "Phone Calls", icon: "pi pi-phone", action: this.processPhoneCalls},
                        {label: "Processes", icon: "pi pi-sitemap", action: this.processProcesses},
                        {label: "Files", icon: "pi pi-folder", action: this.processFiles},
                        {label: "Audit Trail", icon: "pi pi-history", action: this.processAuditTrail},
                        {label: "Products", icon: "pi pi-box", action: this.processProducts},
                        {label: "Suppliers", icon: "pi pi-building", action: this.processSuppliers},
                        {label: "Invoices", icon: "pi pi-file", action: this.processInvoices},
                        {label: "Payments", icon: "pi pi-credit-card", action: this.processPayments},
                        {label: "Billing Runs", icon: "pi pi-refresh", action: this.processBillingRuns},
                        {label: "Unpaid Runs", icon: "pi pi-times-circle", action: this.processUnpaidRuns},
                        {
                            label: "Financial Management",
                            icon: "pi pi-chart-line",
                            action: this.processFinancialManagement
                        },
                        {label: "Reports", icon: "pi pi-chart-bar", action: this.processReports},
                        {label: "Reminders", icon: "pi pi-inbox", action: this.processReminders},
                        {label: "Email Campaigns", icon: "pi pi-send", action: this.processEmailCampaigns},
                    ]
                }
            ]
        }
    },
    methods: {
        closeAllMenus() {
            document.body.click(); // triggers hideOnOutsideClick

            document.querySelectorAll('.p-component-overlay, .p-menu-overlay, .p-overlay, .p-tieredmenu-overlay')
                .forEach(el => el.remove());
        },
        safeNavigate(target) {
            this.closeAllMenus();
            setTimeout(() => {
                this.$router.push(target);
            }, 0);
        },
        processLogout() {
            this.closeAllMenus();

            this.userStore.$reset();
            this.userStore.clearUser();

            this.$router.push('/login');
        },
        processHelp() {
            this.safeNavigate('/commonHelp');
        },
        processDashboard() {
            this.safeNavigate('/faOverviewHome');
        },
        processAuditTrail() {
            this.safeNavigate('/commonOverviewAuditTrail');
        },
        processTasks() {
            this.safeNavigate('/commonOverviewTasks');
        },
        processProcesses() {
            this.safeNavigate('/commonOverviewProcesses');
        },
        processReports() {
            this.safeNavigate('/commonOverviewReports');
        },
        processFiles() {
            this.safeNavigate('/commonOverviewFiles');
        },
        processClients() {
            this.safeNavigate('/commonClients');
        },
        processClientSegments() {
            this.safeNavigate('/commonClientSegments');
        },
        processAppointments() {
            this.safeNavigate('/commonAppointments');
        },
        processReminders() {
            this.safeNavigate('/commonReminders');
        },
        processEmailCampaigns() {
            this.safeNavigate('/commonEmailCampaigns');
        },
        processCalendar() {
            this.safeNavigate('/commonCalendar');
        },
        processProspects() {
            this.safeNavigate('/commonProspects');
        },
        processPhoneCalls() {
            this.safeNavigate('/commonPhoneCalls');
        },
        processDigitalForms() {
            this.safeNavigate('/commonDigitalForms');
        },
        processProducts() {
            this.safeNavigate('/commonProducts');
        },
        processSuppliers() {
            this.safeNavigate('/commonSuppliers');
        },
        processInvoices() {
            this.safeNavigate('/commonFinancialInvoices');
        },
        processPayments() {
            this.safeNavigate('/commonFinancialPayments');
        },
        processBillingRuns() {
            this.safeNavigate('/commonFinancialBillingRuns');
        },
        processUnpaidRuns() {
            this.safeNavigate('/commonFinancialUnpaidRuns');
        },
        processFinancialManagement() {
            this.safeNavigate('/commonFinancialManagement');
        },
        processConfigurationBasic() {
            this.safeNavigate('/commonConfigurationBasic');
        },
        processConfigurationBusiness() {
            this.safeNavigate('/commonConfigurationBusiness');
        },
        processConfigurationTeam() {
            this.safeNavigate('/commonConfigurationTeam');
        },
        processConfigurationBankAccount() {
            this.safeNavigate('/commonConfigurationBankAccounts');
        },
        processConfigurationBilling() {
            this.safeNavigate('/commonConfigurationBilling');
        },
        processConfigurationEmail() {
            this.safeNavigate('/commonConfigurationEmail');
        },
        processConfigurationLocations() {
            this.safeNavigate('/commonConfigurationLocations');
        },
        processConfigurationEmailTemplates() {
            this.safeNavigate('/commonConfigurationTemplates');
        },
        processConfigurationNoteTemplates() {
            this.safeNavigate('/commonConfigurationNoteTemplates');
        },
        processConfigurationProvisions() {
            this.safeNavigate('/commonConfigurationProvisions');
        },
        processConfigurationAvailability() {
            this.safeNavigate('/commonConfigurationAvailability');
        },
        processConfigurationLabels() {
            this.safeNavigate('/commonConfigurationLabels');
        },
        processAccountOverview() {
            this.safeNavigate('/commonProfile');
        },
        processAccountSecurity() {
            this.safeNavigate('/commonProfilePassword');
        },
        processAccountPrepaid() {
            this.safeNavigate('/commonProfileAccount');
        },
        processAccountTermsOfUse() {
            this.safeNavigate('/commonProfileTerms');
        },
        processAccountPrivacyPolicy() {
            this.safeNavigate('/commonProfilePrivacy');
        },
        processAccountApplicationStore() {
            this.safeNavigate('/commonApplicationStore');
        },
        processAccountAdmin() {
            this.safeNavigate('/commonProfileAdmin');
        },
        processAccountSiAdmin() {
            this.safeNavigate('/commonProfileSiAdmin');
        },
        onToggleCompany() {
            this.userStore.activeCompanyId = this.selectedCompany;

            const company = this.userStore.companies.find(
                c => c.id === this.selectedCompany
            );

            if (company) {
                this.userStore.companyName = company.name;
            }

            this.$router.replace({
                path: this.$route.fullPath
            });
        },
    }
}
</script>

<style scoped>
/* Raise entire top navigation bar ABOVE all content */
.navbar-wrapper {
    position: relative;
    z-index: 9999 !important;
}

/* Ensure dropdown menus are on top as well */
.nav-dropdown {
    position: absolute;
    z-index: 10000 !important;
}

</style>
